var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { omitCommonProps } from "./_commonProps";
import { defaultTheme } from "../index";

var UnstyledLogo = function UnstyledLogo(props) {
  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 296.2 303.9" }, omitCommonProps(props)),
    React.createElement("polygon", { points: "296.2,0 0,96.1 0,287.2 25.1,279 25.1,303.9 53.9,269.7 296.2,191.1 " }),
    React.createElement("path", {
      d: "M79.9,187.1l-20,6.6l-2.7,10.4l-13.5,4.5l18.4-66.3l15.7-5.2l18.4,54.1l-13.5,4.5L79.9,187.1z M76.2,175.4 l-6.3-20l-6.3,24.2L76.2,175.4z"
    }),
    React.createElement("path", {
      d: "M136.1,151.5v26.4l-11.6,3.8v-24.5c0-5.3-3-6.8-6.7-5.6c-4.2,1.4-7.2,5.1-7.2,11.2v23.5L99,190.1v-43l11.6-3.8 v4c2.1-3.9,5.9-7.2,11-8.9C129.4,135.9,136.1,139.9,136.1,151.5z"
    }),
    React.createElement("path", {
      d: "M189.2,117.3c0-5,2.9-7,7.2-8.4c2.9-1,6.2-1.8,9.6-2.5V94.5c-3.3,0.3-6.5,0.9-9.6,2 c-12.8,4.2-18.7,12.6-18.7,24.6l-10.5,3.5l0,0l-3.4,1.1l-7.3,28.7l-8.6-23.4l-12.7,4.2l15.4,35.9c-1.7,5.8-4.2,8.5-9.6,10.3v12 c10.8-3,17.7-10.7,22-25.8l9.3-32.4l5.5-1.8V164l11.6-3.8v-30.6l9.9-3.3V157l11.6-3.8v-43L189.2,117.3z"
    }),
    React.createElement("path", {
      d: "M254.7,112.2v26.4l-11.6,3.8v-24.5c0-5.3-3-6.8-6.7-5.6c-4.2,1.4-7.2,5.1-7.2,11.2V147l-11.6,3.8v-43l11.6-3.8 v4c2.1-3.9,5.9-7.2,11-8.9C248,96.6,254.7,100.5,254.7,112.2z"
    })
  );
};

var StyledLogo = styled(UnstyledLogo).withConfig({
  displayName: "Logo__StyledLogo",
  componentId: "sc-169jft-0"
})(["polygon{fill:", ";", ";}path{fill:", ";}"], function (props) {
  return props.background;
}, function (props) {
  return props.basic && css(["display:none;"]);
}, function (props) {
  return props.color;
});

StyledLogo.propTypes = {
  basic: PropTypes.bool,
  color: PropTypes.string,
  background: PropTypes.string
};
StyledLogo.defaultProps = {
  basic: false,
  color: defaultTheme.primary,
  background: "#faa5aa"
};

export default StyledLogo;